import { useEffect } from 'react'
import styled from 'styled-components'

import Herne from '~/shared/assets/images/herne4.png'
import useViewport from '~/shared/hooks/useViewport'
import theme from '~/shared/styles/theme'

function SNS() {
  const viewport = useViewport()
  const isMobile = viewport < theme.deviceSizes.medium

  const Bg = `${import.meta.env.VITE_STATIC_ENDPOINT}/assets/background/2x-1920-bg-home-sns.webp`
  const BgMobile = `${import.meta.env.VITE_STATIC_ENDPOINT}/assets/background/2x-390-bg-home-sns.webp`

  return (
    <Wrapper>
      <ContentBox>
        <Title>ILLUSTAR FES SNS</Title>
        <Desc>
          함께 만들어가는 종합 이벤트 일러스타페스의 이벤트, <br /> 홍보 글을
          확인해 보세요!
        </Desc>
        <TwitterLink href="https://twitter.com/illustar_fes" target="_blank">
          https://twitter.com/illustar_fes
        </TwitterLink>

        <TwitterTimeline />
      </ContentBox>
      <Background src={isMobile ? BgMobile : Bg} alt="sns-background" />
    </Wrapper>
  )
}

export default SNS

const Wrapper = styled.div`
  position: relative;

  display: flex;

  box-sizing: border-box;
  aspect-ratio: 1920/1080;
  width: 100vw;
  height: 1000px;
  padding: 38px 0;

  @media ${theme.device.medium} {
    height: 1100px;
  }
`

const Background = styled.img`
  position: absolute;
  z-index: ${theme.zIndex.belowDefault};
  top: 0;
  right: 0;
  left: 0;

  width: 100%;
  max-width: 1920px;
  height: 100%;
  margin: 0 auto;

  object-fit: contain;

  /* @media ${theme.device.large} {
    gap: 12px;
    align-items: flex-start;
    width: 70%;
    margin-left: 10%;
  } */

  @media ${theme.device.medium} {
    object-fit: cover;
  }
`

const ContentBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  align-items: center;
  justify-content: center;

  width: 100%;

  @media ${theme.device.medium} {
    gap: 40px;
    height: 100%;
  }
`

const Title = styled.h1`
  font-family: NanumSquareNeo-Heavy, sans-serif;
  font-size: 42px;
  font-weight: 500;
  line-height: 58.8px;
  text-align: center;
  letter-spacing: -0.02em;

  @media ${theme.device.medium} {
    font-size: 28px;
    line-height: 39.2px;
  }
`

const Desc = styled.p`
  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 24px;
  font-weight: 400;
  line-height: 33px;
  text-align: center;
  letter-spacing: -0.02em;

  @media ${theme.device.medium} {
    width: 70%;
    font-size: 21px;
    font-weight: 400;
    line-height: 29.4px;
  }
`

const TwitterLink = styled.a`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;

  width: fit-content;
  height: 41px;
  padding: 0 20px;

  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 18px;
  font-weight: 500;
  color: ${theme.colors.black};
  text-align: center;
  text-decoration: none;

  background-color: #eaebeb;
  border: none;
  border-radius: 60px;

  @media ${theme.device.medium} {
    width: auto;
    padding: 0 15px;
    font-size: 15px;
  }
`

const TwitterTimeline = () => {
  useEffect(() => {
    // 트위터 위젯 스크립트 로드
    const script = document.createElement('script')
    script.src = 'https://platform.twitter.com/widgets.js'
    script.async = true
    script.charset = 'utf-8'
    document.body.appendChild(script)

    // 클린업 함수
    return () => {
      document.body.removeChild(script)
    }
  }, [])

  return (
    <TwitterTimelineWrapper>
      <TwitterTimelineContainer>
        <a
          className="twitter-timeline"
          href="https://twitter.com/illustar_fes?ref_src=twsrc%5Etfw"
        >
          Tweets by illustar_fes
        </a>
        <HerneImage src={Herne} alt="herne" />
      </TwitterTimelineContainer>
    </TwitterTimelineWrapper>
  )
}

const TwitterTimelineWrapper = styled.div`
  position: relative;

  @media ${theme.device.medium} {
    width: 90%;
    height: 40%;
  }
`

const TwitterTimelineContainer = styled.div`
  overflow: visible scroll;

  box-sizing: border-box;
  width: 714px;
  height: 527px;

  background: #fff;
  border: 1px solid #c1c3c2;
  border-radius: 12px;

  @media ${theme.device.medium} {
    width: 100%;
  }
`
const HerneImage = styled.img`
  position: absolute;
  top: 350px;
  left: -140px;

  width: 217px;
  height: auto;

  object-fit: cover;

  @media ${theme.device.large} {
    left: -90px;
  }

  @media ${theme.device.medium} {
    top: 440px;
    left: -20px;
    width: 124px;
    height: 153px;
  }
`
